import React from 'react';

const NotFound = () => {
    return (
        <div className='text-center mt-5'>
            <h1>404 Requested page not found!</h1>
        </div>
    );
};

export default NotFound;